import React, { Component } from 'react'
import { Panel } from 'react-bootstrap'
import FormSearch from '../FormSearch/FormSearch.container'

export default class PanelOptions extends Component {
  render(){
    const {
      open, 
    } = this.props

    return(
      <Panel collapsible expanded={open} className={`panel-search ${!open ? 'hidden' : '' }`}>
        <Panel.Collapse>
          <Panel.Body>
            <div className='overlay-info'>
              <FormSearch />
            </div>
          </Panel.Body>
        </Panel.Collapse>
      </Panel>
    )
  }
}



// WEBPACK FOOTER //
// ./src/features/commons/SearchBar/components/PanelOptions/panelOptions.js